import { asRect } from '../../../common/maths/geometry/rect';
import { Rect } from '../../../common/maths/geometry/rect/rectTypes';

export const getHeaderAvoidanceInsets = (gridSize: number): Rect =>
    asRect({
        top: gridSize * 10,
        right: gridSize,
        bottom: gridSize * 2,
        left: gridSize,
    });
